<template>
    <div>
        <div class="mt-4">
            <div v-if="users.length" class="flex flex-wrap">
                <div
                    v-for="(item, index) in users"
                    :key="item.id"
                    class="w-full md:w-1/2 lg:w-4/12 p-2"
                >
                    <div
                        class="flex justify-between p-2 min-h-24 border border-stack-primary rounded"
                    >
                        <div class="flex flex-col justify-around">
                            <span class="text-theme-primary font-bold">
                                {{
                                    item.firstName
                                        ? $options.filters.cut(
                                              `${item.firstName} ${item.lastName}`,
                                              30
                                          )
                                        : item.email
                                }}
                            </span>
                            <span>
                                {{ item.role.name }}
                            </span>
                        </div>

                        <div
                            v-if="enabled && item.email !== user.email"
                            class="flex"
                        >
                            <button
                                class="btn w-3 h-3 flex items-center justify-center"
                                @click="editItem(index)"
                            >
                                🖊
                            </button>
                            <button
                                class="btn btn-danger w-3 h-3 flex items-center justify-center"
                                @click="deleteItem(index)"
                            >
                                🗑️
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="w-10/12 mx-auto py-3">
                <span class="text-lg">
                    Nuestro sistema no ha encotrado usuarios registrados 0️⃣.
                </span>
            </div>
            <div v-if="enabled" class="my-4 w-full flex justify-center">
                <custom-tooltip border>
                    <button
                        class="w-full btn rounded-lg border-2 border-gary-600 h-24 flex justify-center items-center"
                        @click="openNewItem"
                    >
                        <h2 class="text-lg">&nbsp;➕&nbsp;</h2>
                    </button>
                    <template #tooltip> Invitar Colaborador</template>
                </custom-tooltip>
            </div>
        </div>
        <div>
            <app-dialog v-model="isOpenModalSelectItem">
                <template #header>
                    <h3 class="text-lg">Asociar Usuario A Alamacén</h3>
                </template>
                <div class="w-10/12 mx-auto py-2">
                    <span v-if="associatedAt">
                        Este usuario fue asociado al tiendael
                        {{ associatedAt | date }}. Selecciona el rol que quieres
                        asignarle al usuario.
                    </span>
                    <span v-else>
                        Ingresa el correo electrónico y selecciona el rol que
                        quieres asignarle al usuario.
                    </span>
                    <div class="my-4">
                        <span> Email </span>
                        <custom-input
                            id="email"
                            v-model="email"
                            :disabled="isEditingItem"
                            autocomplete="off"
                            type="text"
                            name="email"
                            :error="
                                introEmail && !isValidEmail
                                    ? 'Ingrese correo valido'
                                    : ''
                            "
                        />
                    </div>

                    <div v-if="showDuplicate" class="mx-3 mt-2">
                        <span class="text-lg text-danger mt-4">
                            Ya tienes un usuario con el correo
                            {{ email }}
                        </span>
                    </div>

                    <card-selector v-model="role" :base="options" />

                    <div class="flex justify-center mt-4">
                        <app-button
                            :disabled="isInvalidCurrentItem"
                            class="mt-3 mb-5 w-3/4 mx-auto"
                            border
                            gradient
                            @click="pushOrUpdateItem"
                        >
                            <span class="text-lg">
                                {{
                                    isEditingItem
                                        ? "Actualizar usuario ✔️"
                                        : "Agregar usuario ✔️"
                                }}</span
                            >
                        </app-button>
                    </div>
                </div>
            </app-dialog>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import { emailRegex } from "@/common/lib/regex";

import AppDialog from "@/components/utils/AppDialog.vue";
import CardSelector from "@/components/utils/CardSelector.vue";
import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "UsersRolesManage",
    components: { AppDialog, CardSelector, CustomInput },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            type: Array,
            default: () => [],
            required: true
        },
        enabled: {
            default: () => false,
            type: Boolean,
            required: false
        },
        defaultFilters: {
            default: () => ({}),
            type: Object,
            required: false
        }
    },
    data: () => ({
        role: "",
        email: "",
        associatedAt: "",
        introEmail: false,
        isLoading: false,
        isEditingItem: false,
        isOpenModalSelectItem: false,
        options: [],
        users: [
            {
                id: "",
                uid: "",
                email: "",
                firstName: "",
                identificationNumber: "",
                identificationType: "",
                lastName: "",
                phone: "",
                associatedAt: "",
                role: {
                    slug: "",
                    name: ""
                }
            }
        ]
    }),
    computed: {
        ...mapState("auth", ["user"]),
        ...mapGetters("control", ["backgroundColor"]),
        isValidEmail() {
            return emailRegex.test(this.email);
        },
        showDuplicate() {
            if (this.isEditingItem) return false;
            return this.itemsCurrent.some((item) => item.email === this.email);
        },
        isInvalidCurrentItem() {
            return this.role === "" || !this.isValidEmail;
        }
    },
    watch: {
        itemsCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemsCurrent);
    },
    methods: {
        ...mapActions("roles", ["listAllRoles"]),
        async listRolesComponent() {
            this.isLoading = true;
            try {
                const items = await this.listAllRoles({
                    ...this.defaultFilters
                });
                this.options = items.map((item) => ({
                    id: item.slug,
                    name: item.name,
                    description: item.description,
                    icon: "💠"
                }));
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        setInput(value) {
            this.users = [...value];
        },
        editItem(fromIndex) {
            this.isEditingItem = true;
            let arrAux = [...this.itemsCurrent];
            const itemFound = arrAux[fromIndex];
            this.isOpenModalSelectItem = true;
            this.email = itemFound.email;
            this.associatedAt = itemFound?.associatedAt;
            if (this.options.length) {
                return;
            }
            this.options = [
                {
                    id: itemFound.role.slug,
                    name: itemFound.role.name,
                    description: itemFound.role.name,
                    icon: "💠"
                }
            ];
            this.role = itemFound.role.slug;
            this.listRolesComponent();
        },
        openNewItem() {
            this.isEditingItem = false;
            this.isOpenModalSelectItem = true;
            this.email = "";
            this.associatedAt = "";
            this.listRolesComponent();
        },
        pushOrUpdateItem() {
            const itemsAux = [...this.itemsCurrent];
            const role = this.options.find((item) => item.id === this.role);
            if (this.isEditingItem) {
                const itemAux = itemsAux.findIndex(
                    (item) => item.email === this.email
                );

                itemsAux[itemAux] = {
                    ...itemsAux[itemAux],
                    role: {
                        slug: role.id,
                        name: role.name,
                        description: role.description
                    }
                };
                this.isEditingItem = false;
            } else {
                itemsAux.push({
                    email: this.email,
                    role: {
                        name: role.name,
                        slug: role.id,
                        description: role.description
                    }
                });
            }
            this.$emit("change", itemsAux);
            this.isOpenModalSelectItem = false;
        },
        deleteItem(fromIndex) {
            let itemsResult = [...this.itemsCurrent];
            itemsResult.splice(fromIndex, 1);
            this.$emit("change", itemsResult);
        },
        onBlurEmail() {
            this.introEmail = true;
            this.email = this.email.toLowerCase().trim();
        }
    }
};
</script>
